var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPipes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "7.751 0 389.629 347.15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#3b719e;}.cls-3,.cls-4,.cls-7{fill:#24427c;}.cls-4,.cls-7{mix-blend-mode:multiply;}.cls-4{opacity:0.2;}.cls-5{fill:#4fbcd8;}.cls-6{fill:#418ca3;}.cls-7{opacity:0.52;}.cls-8{fill:#18ffff;}.cls-11,.cls-8,.cls-9{stroke:#ade4f1;}.cls-10,.cls-11,.cls-8,.cls-9{stroke-miterlimit:10;}.cls-10,.cls-11,.cls-9{fill:none;}.cls-10,.cls-9{stroke-width:7.75px;}.cls-10{stroke:#18ffff;}.cls-11{stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.72,
    y: 293.99,
    width: 394.66,
    height: 26.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 209.28,
    y: 291.08,
    width: 9.45,
    height: 31.97
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "396.38 309.98 295.35 309.98 289.56 309.98 104 309.98 98.22 309.98 4.33 309.98 4.33 320.15 98.22 320.15 98.22 323.06 104 323.06 104 320.15 289.56 320.15 289.56 323.06 295.35 323.06 295.35 320.15 396.38 320.15 396.38 309.98"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 4.33,
    y: 85.89,
    width: 392.29,
    height: 26.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 233.51,
    y: 82.98,
    width: 9.45,
    height: 31.97
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "396.62 101.88 312.13 101.88 305.99 101.88 109.02 101.88 102.88 101.88 3.21 101.88 3.21 112.05 102.88 112.05 102.88 114.96 109.02 114.96 109.02 112.05 305.99 112.05 305.99 114.96 312.13 114.96 312.13 112.05 396.62 112.05 396.62 101.88"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 5.25,
    y: 162.44,
    width: 391.9,
    height: 26.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 42.58,
    y: 159.54,
    width: 9.45,
    height: 31.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 355.05,
    y: 159.54,
    width: 9.45,
    height: 31.97
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "397.15 178.43 364.49 178.43 355.05 178.43 52.02 178.43 42.58 178.43 5.25 178.43 5.25 188.6 42.58 188.6 42.58 191.51 52.02 191.51 52.02 188.6 355.05 188.6 355.05 191.51 364.49 191.51 364.49 188.6 397.15 188.6 397.15 178.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "396.88 328.9 339.24 271.26 3.13 271.26 3.13 263.5 342.45 263.5 396.88 317.93 396.88 328.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "2.89 255.89 62.53 196.25 221.43 196.25 255.98 230.79 396.88 230.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "3.83 120.26 74.64 49.45 396.88 49.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "2.74 196.81 73.55 126 182.68 126 223.7 164.77 316.06 164.77 355.21 126 396.88 126"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "3.18 76.79 73.98 5.98 184.96 5.98"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 189.44,
    cy: 5.98,
    r: 4.48
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "3.39 315.47 124.99 315.47 148.24 338.73"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 151.99,
    cy: 341.17,
    r: 4.48
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipes);
export default __webpack_public_path__ + "static/media/Pipes.247a778b337042dff5c87f0f878c5c34.svg";
export { ForwardRef as ReactComponent };